export default __webpack_public_path__ + "static/media/img5.847173fe.png";